import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getInvoices, deleteInvoice } from "../api/invoices";
import { downloadPDF } from "../api/invoices";
import SuccessModal from "../components/SuccessModal";
import { useAuth } from "../context/AuthContext";

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
const [modalOpen, setModalOpen] = useState(false);

const [modalMessage, setModalMessage] =
  useState("");

const [modalTitle, setModalTitle] =
  useState("");
const [mobileMenu, setMobileMenu] =
  useState(false);
const navigate = useNavigate();

const {
  user,
  logout
} = useAuth();

const [loggingOut, setLoggingOut] =
  useState(false);

const [isError, setIsError] =
  useState(false);
  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const res = await getInvoices();
      // console.log("API RESPONSE:", res.data);

      setInvoices(res.data.invoices || []);
    } catch (err) {
      console.error(err);
    }
  };
  const handleLogout = async () => {

  try {

    setLoggingOut(true);

    await logout();

    navigate("/");

  } catch (err) {

    console.error(err);

    setLoggingOut(false);
  }
};
// const handleDownload = async (id, invoiceNumber) => {
//   try {
//     const res = await downloadPDF(id);

//     const url = window.URL.createObjectURL(
//       new Blob([res.data], { type: "application/pdf" })
//     );

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${invoiceNumber}.pdf`;
//     a.click();

//     window.URL.revokeObjectURL(url);
//   } catch (err) {
//     console.error(err);
//     alert("PDF download failed");
//   }
// };
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete invoice?")) return;

//     try {
//       await deleteInvoice(id);
//       fetchInvoices();
//     } catch (err) {
//       console.error(err);
//     }
//   };
const handleDownload = async (
  id,
  invoiceNumber
) => {

  try {

    const res =
      await downloadPDF(id);

    const url =
      window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/pdf",
        })
      );

    const a =
      document.createElement("a");

    a.href = url;

    a.download =
      `${invoiceNumber}.pdf`;

    a.click();

    window.URL.revokeObjectURL(
      url
    );

    setIsError(false);

    setModalTitle(
      "PDF Downloaded"
    );

    setModalMessage(
      `Invoice ${invoiceNumber} downloaded successfully.`
    );

    setModalOpen(true);

  } catch (err) {

    console.error(err);

    setIsError(true);

    setModalTitle(
      "Download Failed"
    );

    setModalMessage(
      err.response?.data?.message ||
      "PDF download failed"
    );

    setModalOpen(true);
  }
};

const handleDelete = async (id) => {

  if (
    !window.confirm(
      "Delete invoice?"
    )
  ) return;

  try {

    await deleteInvoice(id);

    fetchInvoices();

    setIsError(false);

    setModalTitle(
      "Invoice Deleted"
    );

    setModalMessage(
      "Invoice deleted successfully."
    );

    setModalOpen(true);

  } catch (err) {

    console.error(err);

    setIsError(true);

    setModalTitle(
      "Delete Failed"
    );

    setModalMessage(
      err.response?.data?.message ||
      "Failed to delete invoice"
    );

    setModalOpen(true);
  }
};
  return (
    
    <div className="invoice-layout">
      <style>{`
*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}

body{
  overflow-x:hidden;
  font-family:sans-serif;
  background:#f5f4f0;
}

/* =========================
   LAYOUT
========================= */

.invoice-layout{
  display:flex;
  min-height:100vh;
  background:#f5f4f0;
}

/* =========================
   SIDEBAR
========================= */

.sidebar{
  width:240px;
  background:#2d2b69;
  color:white;
  min-height:100vh;
  display:flex;
  flex-direction:column;
  flex-shrink:0;
}

.sidebar-logo{
  padding:28px 55px 20px;
  border-bottom:1px solid rgba(255,255,255,0.1);
}

.mark{
  font-size:22px;
  font-weight:700;
}

.sub{
  font-size:10px;
  color:rgba(255,255,255,0.45);
  margin-top:4px;
  letter-spacing:1px;
}

.sidebar-nav{
  padding:20px 12px;
  flex:1;
}

.nav-item{
  display:flex;
  align-items:center;
  gap:10px;
  padding:11px 12px;
  border-radius:10px;
  margin-bottom:4px;
  font-size:13px;
  font-weight:500;
  color:rgba(255,255,255,0.7);
  text-decoration:none;
  transition:0.2s;
}

.nav-item:hover,
.nav-item.active{
  background:rgba(255,255,255,0.12);
  color:white;
}

.nav-icon{
  width:18px;
  text-align:center;
}

/* =========================
   MAIN
========================= */

.main-content{
  flex:1;
  padding:40px;
  width:100%;
}

.page-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:30px;
  gap:20px;
}

.page-title{
  font-size:34px;
  font-weight:700;
}

.page-sub{
  color:#777;
  margin-top:6px;
}

.new-btn{
  background:#2d2b69;
  color:white;
  padding:12px 18px;
  border-radius:12px;
  text-decoration:none;
  white-space:nowrap;
}

/* =========================
   TABLE CARD
========================= */

.table-card{
  background:white;
  border-radius:20px;
  padding:24px;
  overflow-x:auto;
}

.invoice-table{
  width:100%;
  border-collapse:collapse;
  min-width:750px;
}

.invoice-table th{
  text-align:left;
  padding-bottom:14px;
}

.invoice-table td{
  padding:14px 0;
  border-top:1px solid #eee;
}

.action-group{
  display:flex;
  gap:8px;
  flex-wrap:wrap;
}

.btn{
  border:none;
  padding:7px 10px;
  border-radius:7px;
  color:white;
  font-size:12px;
  cursor:pointer;
  text-decoration:none;
}

.btn-view{
  background:#2d2b69;
}

.btn-edit{
  background:#f59e0b;
}

.btn-pdf{
  background:#059669;
}

.btn-delete{
  background:#dc2626;
}

/* =========================
   MOBILE MENU
========================= */

.mobile-menu-btn{
  display:none;
}

.mobile-overlay{
  display:none;
}

/* =========================
   RESPONSIVE
========================= */

@media(max-width:768px){

  .invoice-layout{
    display:block;
  }

  .mobile-menu-btn{
    display:flex;
    position:fixed;
    top:14px;
    left:14px;
    width:42px;
    height:42px;
    border:none;
    border-radius:10px;
    background:#2d2b69;
    color:white;
    font-size:22px;
    align-items:center;
    justify-content:center;
    z-index:1001;
    cursor:pointer;
  }

  .mobile-overlay{
    display:block;
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.4);
    opacity:0;
    pointer-events:none;
    transition:0.3s;
    z-index:998;
  }

  .mobile-overlay.show{
    opacity:1;
    pointer-events:auto;
  }

  .sidebar{
    position:fixed;
    top:0;
    left:0;
    width:240px;
    height:100vh;
    z-index:999;
    overflow-y:auto;

    transform:translateX(-100%);
    transition:transform 0.3s ease;
  }

  .sidebar.mobile-open{
    transform:translateX(0);
  }

  .main-content{
    padding:70px 14px 20px;
  }

  .page-header{
    flex-direction:column;
    align-items:flex-start;
  }

  .new-btn{
    width:100%;
    text-align:center;
  }

  .page-title{
    font-size:30px;
  }
}
  /* =========================
   SIDEBAR FOOTER
========================= */

.sidebar-footer{
  padding:16px 12px;
  border-top:1px solid rgba(255,255,255,0.1);
}

.user-row{
  display:flex;
  align-items:center;
  gap:10px;
}

.user-avatar{
  width:36px;
  height:36px;
  border-radius:10px;
  background:rgba(255,255,255,0.15);
  overflow:hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  color:white;
  font-weight:700;
  flex-shrink:0;
}

.user-avatar img{
  width:100%;
  height:100%;
  object-fit:cover;
}

.user-name{
  font-size:13px;
  font-weight:600;
  color:white;
}

.user-plan{
  font-size:10px;
  color:rgba(255,255,255,0.45);
  margin-top:2px;
  letter-spacing:1px;
  text-transform:uppercase;
}

.logout-btn{
  width:100%;
  margin-top:14px;
  border:none;
  background:rgba(255,255,255,0.08);
  color:rgba(255,255,255,0.7);
  padding:10px;
  border-radius:10px;
  cursor:pointer;
  transition:0.2s;
  font-size:13px;
}

.logout-btn:hover{
  background:rgba(255,80,80,0.18);
  color:#ffb4b4;
}
`}</style>
      <SuccessModal
  open={modalOpen}
  title={modalTitle}
  message={modalMessage}
  isError={isError}
  buttonText={
    isError
      ? "Close"
      : "Continue"
  }
  onClose={() =>
    setModalOpen(false)
  }
/>
      <>
  {/* MOBILE MENU BUTTON */}
  <button
    className="mobile-menu-btn"
    onClick={() =>
      setMobileMenu(!mobileMenu)
    }
  >
    ☰
  </button>

  {/* OVERLAY */}
  <div
    className={`mobile-overlay ${
      mobileMenu ? "show" : ""
    }`}
    onClick={() =>
      setMobileMenu(false)
    }
  />

  <aside
    className={`sidebar ${
      mobileMenu
        ? "mobile-open"
        : ""
    }`}
  >
    <div className="sidebar-logo">
      <div className="mark">
        Invoice AI
      </div>

      <div className="sub">
        GST · AI · India
      </div>
    </div>

    <nav className="sidebar-nav">

      <Link
        to="/dashboard"
        className="nav-item"
      >
        <span className="nav-icon">
          ▦
        </span>
        Dashboard
      </Link>

      <Link
        to="/"
        className="nav-item"
      >
        <span className="nav-icon">
          ✨
        </span>
        WelcomePage
      </Link>

      {/* ACTIVE */}
      <Link
        to="/invoices"
        className="nav-item active"
      >
        <span className="nav-icon">
          📄
        </span>
        Invoices
      </Link>

      <Link
        to="/invoice/new"
        className="nav-item"
      >
        <span className="nav-icon">
          ＋
        </span>
        New Invoice
      </Link>

      <Link
        to="/invoice/ai"
        className="nav-item"
      >
        <span className="nav-icon">
          ✦
        </span>
        AI Generate
      </Link>

      <Link
        to="/settings"
        className="nav-item"
      >
        <span className="nav-icon">
          ⚙
        </span>
        Settings
      </Link>

      <Link
        to="/billing"
        className="nav-item"
      >
        <span className="nav-icon">
          💳
        </span>
        Billing
      </Link>

    </nav>
     <div className="sidebar-footer">
            <div className="user-row">
              <div className="user-avatar">
                {user?.picture ? <img src={user.picture} alt="" referrerPolicy="no-referrer" /> : (user?.name || "U")[0].toUpperCase()}
              </div>
              <div>
                <div className="user-name">{user?.name || "User"}</div>
                <div className="user-plan">{user.plan || "free"} plan</div>
              </div>
            </div>
            {/* <button className="logout-btn" onClick={handleLogout}>Sign out</button> */}
            <button className="logout-btn" onClick={handleLogout} disabled={loggingOut}>
            {loggingOut ? (
              <><span className="spinner" /> Signing out...</>
            ) : (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
                </svg> &nbsp;
                Sign out
              </>
            )}
          </button>
          </div>
  </aside>
</>

     <main className="main-content">
        <div className="page-header">

  <div>
    <h1 className="page-title">
      Invoices
    </h1>

    <p className="page-sub">
      Manage all your invoices
    </p>
  </div>

  <Link
    to="/invoice/new"
    className="new-btn"
  >
    + New Invoice
  </Link>

</div>
        <div className="table-card">

  <table className="invoice-table">
            <thead>
              <tr>
                <th align="left">Invoice</th>
                <th align="left">Client</th>
                <th align="left">Amount</th>
                <th align="left">Status</th>
                <th align="left">Actions</th>
              </tr>
            </thead>

            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice._id}>
                  <td>{invoice.invoiceNumber}</td>
                  <td>{invoice.client?.name}</td>
                  <td>₹{invoice.totalAmount}</td>
                  <td>{invoice.status}</td>

                 <td>
  <div className="action-group">

    <Link
      to={`/invoice/${invoice._id}`}
      className="btn btn-view"
    >
      View
    </Link>

    <Link
      to={`/invoice/edit/${invoice._id}`}
      className="btn btn-edit"
    >
      Edit
    </Link>

    <button
      onClick={() =>
        handleDownload(
          invoice._id,
          invoice.invoiceNumber
        )
      }
      className="btn btn-pdf"
    >
      PDF
    </button>

    <button
      onClick={() =>
        handleDelete(invoice._id)
      }
      className="btn btn-delete"
    >
      Delete
    </button>

  </div>
</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}

const navStyle = (active = false) => ({
  display: "block",
  padding: "10px 14px",
  marginBottom: 10,
  borderRadius: 10,
  textDecoration: "none",
  color: active ? "white" : "rgba(255,255,255,0.7)",
  background: active ? "rgba(255,255,255,0.1)" : "transparent",
});